/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import queryString from "query-string";
import { isEmpty } from '../../../utils/lodashExtend';
import { useSelector } from 'react-redux';
import { permissionCheck } from '../../../utils/permission';
import SalesEtcInvoice from './SalesEtcInvoice';

const QuotationOrder = () => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [activeTab, setActiveTab] = useState(0);
  const [targetPermission, setTargetPermission] = useState(null);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("");


  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'TRADE_INVOICE');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "TRADE_INVOICE");
      }
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/electronic/quotation-order?tab=${value}`);
  };

  const tabList = [
    { label: "견적서", action: _setActiveTab, value: 'quotation' },
    { label: "발주서", action: _setActiveTab, value: 'order' },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  const headerButtons = [
    {
      isHide: activeTab === 'order' || (targetPermission && targetPermission.level <= 1),
      label: "견적서 등록",
      action: () => {
        setMode("create");
        setOpen(true);
      },
    },
    {
      isHide: activeTab === 'quotation' || (targetPermission && targetPermission.level <= 1),
      label: "발주서 등록",
      action: () => {
        setMode("create");
        setOpen(true);
      },
    },
  ];

  return (
    <>
      <div className="print-out">
        <PageHeader
          title={`${activeTab === 'quotation' ? "견적서" : "발주서"}`}
          tabList={tabList}
          activeTab={activeTab}
          buttons={headerButtons}
        />
        {!isEmpty(targetPermission) && (
          <>
            <SalesEtcInvoice
              permission={targetPermission}
              open={open}
              setOpen={setOpen}
              mode={mode}
              setMode={setMode}
              type={activeTab}
            />
          </>
        )}
      </div>
    </>
  );
};

export default QuotationOrder;